var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoot = function SvgShoot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Group 43",
    transform: "translate(-694.944 -217.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.754,230.385H717.19c-.719-1.016-1.355-1.516-1.939-1.527-.779-.015-2.835-.009-4.241,0l-1.175,0c-.537,0-1.11.5-1.745,1.528h-2.8a1.349,1.349,0,0,0-1.347,1.346v8.394a1.349,1.349,0,0,0,1.347,1.346h14.463a1.349,1.349,0,0,0,1.346-1.346V231.73A1.348,1.348,0,0,0,719.754,230.385Zm-3.768,5.219a3.464,3.464,0,1,1-3.464-3.463A3.468,3.468,0,0,1,715.985,235.6Zm2.644-2.144a.772.772,0,1,1,.772-.772A.772.772,0,0,1,718.629,233.459Z",
    "data-name": "Path 90",
    transform: "translate(-.156 -.183)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.509,
    cy: 2.509,
    r: 2.509,
    "data-name": "Ellipse 17",
    transform: "translate(709.858 232.912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.415,230.186h-1.821a.336.336,0,0,1,0-.672h1.821a.336.336,0,1,1,0,.672Z",
    "data-name": "Path 91",
    transform: "translate(-.207 -.209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.954,226.329h-1.568v-1.567a.625.625,0,1,0-1.249,0v1.567H700.57a.625.625,0,1,0,0,1.25h1.568v1.568a.625.625,0,0,0,1.249,0V227.58h1.568a.625.625,0,1,0,0-1.25Z",
    "data-name": "Path 92"
  }))));
};
export default SvgShoot;